import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { registerAppNavigator } from '@/lib/appNavigator'

export default function AppNavigatorBridge() {
  const navigate = useNavigate()

  useEffect(() => registerAppNavigator(navigate), [navigate])

  return null
}
